import React, { useContext, useEffect, useState } from "react";
import './styles.css';
import Sidebar from "../../layout/Sidebar/SideBar";
import Navbar from "../../layout/Navbar/Navbar";
import Context from "../../context/Context";
import Loading from "../../components/Loading";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  debounce
} from "@mui/material";
import {
  Col,
  Container,
  Row,
  Form,
  FormCheck,
  InputGroup
} from "react-bootstrap";
import {
  DatePicker,
  LocalizationProvider
} from "@mui/x-date-pickers";
import { Modal } from "react-bootstrap";
import blogFetch from "../../axios/config";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from 'dayjs';
import { FormatDate } from "../../utils/DataUtils";

export const HistoricWagon = () => {
  const {
    loading,
    setLoading
  } = useContext(Context);

  const [showImage, setShowImage] = useState(false);
  const [imageSrc, setImageSrc] = useState('');
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [furnace, setFurnace] = useState([])
  const [selectedfurnace, setSelectedFurnace] = useState()
  const [searchVagaoHistorico, setSearchVagaoHistorico] = useState('');
  const [historicWagon, setHistoricWagon] = useState([])
  const [dtInicio, setDtInicio] = useState(dayjs().subtract(3, 'day'));
  const [dtFim, setDtFim] = useState(dayjs());



  const getFurnace = async () => {
    try {
      const { data } = await blogFetch.get("/SAGA_Fornos")
      setFurnace(data);
      return data;
    } catch {
      console.error("Error")
    }
  }

  const getWagonHistory = async (dtInicio, dtFim, furnace) => {
    setLoading(true)
    try {
      const { data } = await blogFetch.get("/ISAGA_VagoesFornosPecas/historico", {
        params: {
          furnace,
          startDate: dtInicio.toISOString(),
          endDate: dtFim.toISOString(),
        }
      });
      setHistoricWagon(data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };


  const getSearchWagon = async (searchVagaoHistorico) => {
    setLoading(true);
    try {
      const { data } = await blogFetch.get("/ISAGA_VagoesFornosPecas/search", {
        params: {
          dado: searchVagaoHistorico
        }
      });

      setHistoricWagon(data)
      
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };


  


  useEffect(() => {
    getFurnace();
  }, []);

  useEffect(() => {
    if (dtInicio && dtFim && selectedfurnace)
      getWagonHistory(dtInicio, dtFim, selectedfurnace);
  }, [dtFim, dtInicio, selectedfurnace]);



  useEffect(() => {
    
    if (searchVagaoHistorico) {
      getSearchWagon(searchVagaoHistorico);
    } else {
      getWagonHistory(dtInicio, dtFim, selectedfurnace);
    }
  }, [searchVagaoHistorico]);



  const handleShowImage = (image, index) => {
    setImageSrc(image);
    setSelectedIndex(index);
    setShowImage(true);
  };

  const handleCloseImage = () => {
    setShowImage(false);
    setSelectedIndex(null);
  };


  console.log(historicWagon)


  return (
    <>
      <Navbar />
      <Sidebar />
      <div className="selectFurnace">
      <Form>
        <div className="wagon-radio mb-3 py-2 d-flex flex-auto justify-content-center align-items-center">
          {furnace.map((item) => (
            <FormCheck
              className="px-4"
              value={item.forno_Name}
              onClick={() => {
                getWagonHistory(item.forno_Name);
                setSelectedFurnace(item.forno_Name);
              }}
              key={item.forno_Name}
              label={item.forno_Name}
              name="group1"
              type="radio"
            />
          ))}
        </div>
      </Form>
      </div>

      <div className="app_body " >
        <div className="d-flex mx-2">
          <LocalizationProvider
            className="m-3"
            dateAdapter={AdapterDayjs}
            fullWidth
            adapterLocale="pt-br">
            <DatePicker
              label="De"
              className="m-3"
              value={dtInicio}
              onChange={(newValue) => setDtInicio(newValue ? newValue.toDate() : new Date())}/>

          </LocalizationProvider>

          <LocalizationProvider
            dateAdapter={AdapterDayjs}
            fullWidth
            adapterLocale="pt-br">
            <DatePicker
              label="Até"
              className="m-3"
              value={dtFim}
              onChange={(newValue) => setDtFim(newValue ? newValue.toDate() : new Date())}
            />
          </LocalizationProvider>

          <InputGroup className="m-3">
            <Form.Control
              placeholder="Buscar Ordem Serial ou Código do Vagão"
              value={searchVagaoHistorico}
              onChange={({ target }) => {
                setSearchVagaoHistorico(target.value)
              }}
              onSubmit={() => {getSearchWagon(searchVagaoHistorico)}}
              />

          </InputGroup>
        </div>

        <div className="filawrap" style={{ minHeight: '85vh', maxHeight: '85vh', overflow: 'auto' }}>
          <Container fluid>
            <Row>
              {!loading ?
                <Col>
                  {historicWagon.map((parts, index) => (
                    <Accordion className="mx-2 my-4 p-3 rounded-lg shadow-lg" key={index}>
                    <AccordionSummary>
                      <div className="overflow-x-auto shadow-md rounded-lg">
                        <table className="min-w-full text-center " style={{ tableLayout: 'fixed', width: '100%' }}>

                          <thead>
                            <tr>
                              <th style={{color: '#1d4ed8'}} className="py-3 px-4 uppercase text-md">VAGÃO SERIAL</th>
                              <th style={{color: '#1d4ed8'}} className="py-3 px-4 uppercase text-md">CRIADO</th>
                              <th style={{color: '#1d4ed8'}} className="py-3 px-4 uppercase text-md">LIBERADO</th>
                              <th style={{color: '#1d4ed8'}} className="py-3 px-4 uppercase text-md">ENTRADA</th>
                              <th style={{color: '#1d4ed8'}} className="py-3 px-4 uppercase text-md">SAÍDA</th>
                              <th style={{color: '#1d4ed8'}} className="py-3 px-4 uppercase text-md ">APROVADO</th>
                              <th style={{color: '#1d4ed8'}} className="py-3 px-4 uppercase text-md">FOTO</th>
                            </tr>
                          </thead>

                          <tbody className="bg-gray-100 dark:bg-gray-800 text-gray-900 dark:text-white">
                            <tr className="border-b border-gray-400 dark:border-gray-700 hover:bg-gray-200 dark:hover:bg-gray-700">
                              <td style={{color: '#93c5fd'}} className="text-sm">{parts.wagon?.[0]?.vagao_Serial || 'Não disponível'}</td>
                              <td style={{color: '#93c5fd'}}  className="text-sm">{parts.wagon?.[0]?._ts_Creat ? FormatDate(parts.wagon[0]._ts_Creat) : 'Não disponível'}</td>
                              <td style={{color: '#93c5fd'}}  className="text-sm">{parts.wagon?.[0]?._ts_Mod_Liberado ? FormatDate(parts.wagon[0]._ts_Mod_Liberado) : 'Não disponível'}</td>
                              <td style={{color: '#93c5fd'}}  className="text-sm">{parts.wagon?.[0]?._ts_Mod_Entrada ? FormatDate(parts.wagon[0]._ts_Mod_Entrada) : 'Não disponível'}</td>
                              <td style={{color: '#93c5fd'}}  className="text-sm">{parts.wagon?.[0]?._ts_Mod_Saida ? FormatDate(parts.wagon[0]._ts_Mod_Saida) : 'Não disponível'}</td>
                              <td style={{color: '#93c5fd'}}  className="text-sm">{parts.wagon?.[0]?._ts_Mod_Aprovado ? FormatDate(parts.wagon[0]._ts_Mod_Aprovado) : 'Não disponível'}</td>
                              <td className="text-sm" style={{color: '#93c5fd'}}>
                              {parts.wagon?.[0]?.vagao_Image ? (
                                  
                                  <Button
                                    className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                                    variant="contained"
                                    onClick={() => handleShowImage(parts.wagon[0].vagao_Image)}>
                                    Foto
                                  </Button>
                              ): 'Não disponível'}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </AccordionSummary>

                  
                    <AccordionDetails>
                      {!loading ? (
                        <div className="overflow-x-auto shadow-md rounded-lg">
                          
                          <table className="min-w-full text-sm text-center text-gray-500 dark:text-gray-400" style={{ tableLayout: 'fixed', width: '100%' }} >
                            <thead className="bg-gray-50 dark:bg-gray-700 text-gray-700 dark:text-gray-400 uppercase">
                              <tr>
                                <th className="text-center text-md">OP</th>
                                <th className="text-center text-md">M² PEÇA</th>
                                <th className="text-center text-md">PEÇA</th>
                                <th className="text-center text-md">PRODUTO</th>
                                <th className="text-center text-md">VEÍCULO</th>
                                <th className="text-center text-md">MOLDE CÓDIGO</th>
                                <th className="text-center text-md">MOLDE</th>
                              </tr>
                            </thead>
                            <tbody className="grid m-2 border border-gray-300 dark:border-gray-700">
                              {parts.wagon.map((part, partIndex) => (
                                <tr
                                  key={partIndex}
                                  className=" grid grid-cols-7 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-600 border-b dark:border-gray-700"
                                >
                                  <td className="px-1 text-sm text-gray-800 dark:text-white text-center border border-gray-300 dark:border-gray-600">
                                    {part.ordem_Serial}
                                  </td>
                                  <td className="text-center text-md border border-gray-300 dark:border-gray-600">
                                    {(parts.wagon.reduce((sum, item) => sum + item.m2_Peca, 0) / 4.5).toFixed(3)}
                                  </td>
                                  <td className="text-center text-md border border-gray-300 dark:border-gray-600">
                                    {part.ordem_Part_Short}
                                  </td>
                                  <td className="text-center text-md border border-gray-300 dark:border-gray-600">
                                    {part.subProduto_Desc}
                                  </td>
                                  <td className="text-center text-md border border-gray-300 dark:border-gray-600">
                                    {part.ordem_VehDesc}
                                  </td>
                                  <td className="text-center text-md border border-gray-300 dark:border-gray-600">
                                    {part.molde_Codigo}
                                  </td>
                                  <td className="text-center text-sm border border-gray-300 dark:border-gray-600">
                                    {part.molde_Descricao}
                                  </td>
                                </tr>
                              ))}
                            </tbody>

                          </table>
                        </div>
                      ) : (
                        <Loading />
                      )}
                    </AccordionDetails>
                  </Accordion>
                  ))}
                  <Modal
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    show={showImage && selectedIndex !== null}
                    onHide={handleCloseImage}
                    centered
                  >
                    <Modal.Header closeButton>
                    </Modal.Header>
                    <Modal.Body>
                      <img className="w-100" src={imageSrc} alt="Vagao Image" />
                    </Modal.Body>
                  </Modal>
                </Col>
                : (<Loading />)}
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
};
